export const isString = (value: unknown): value is string =>
  typeof value === 'string'

export const fieldOf = (value: unknown, key: string): unknown =>
  typeof value === 'object' && value !== null
    ? Object.getOwnPropertyDescriptor(value, key)?.value
    : undefined

interface SourceFilter {
  field: string
  value: string
}

export const isSourceFilter = (value: unknown): value is SourceFilter =>
  isString(fieldOf(value, 'field')) && isString(fieldOf(value, 'value'))

export const stringsOf = (value: unknown): string[] =>
  Array.isArray(value) ? value.filter(isString) : []
